class ProductOptionsCarousel {
    constructor() {
        this.hulkOptions = document.querySelector("[id^='hulkapps_option_list_']");
        if (!this.hulkOptions) return;

        this.optionSet = this.hulkOptions.querySelector(".hulkapps_option_set");
        this.currentStep = 0;
        this.steps = [
            { key: 'loft', label: 'Head' },
            { key: 'shaft', label: 'Shaft' },
            { key: 'grip', label: 'Grip' }
        ];
        
        this.init();

    }

    init() {
        this.setupCustomToggle();
        this.createCarouselStructure();
        this.setupNavigation();
        this.setupButtons();
        this.setupSubmitButtons();
        this.setupDropdownListeners();
        this.applyStyles();
        this.setupValidationHandler();
        this.showStep(0);
        
        setTimeout(() => {
            this.adjustHeight(0);
        }, 100);
        
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.adjustHeight(this.currentStep);
            }, 250);
        });
    }

setupCustomToggle() {
    // Color configuration
    const colors = {
        selected: {
            background: 'black',
            text: '#fff'
        },
        unselected: {
            background: 'transparent',
            text: '#000'
        }
    };

    const dropdownContainer = this.optionSet.querySelector(".hulk-type .hulkapps_option_value");
    if (!dropdownContainer) return;

    const dropdown = dropdownContainer.querySelector("select");
    const hiddenInput = dropdownContainer.querySelector(".hulk_dropdown_hidden_prop");
    
    if (!dropdown) return;

    const quantitySelector = document.querySelector('[data-block-type="quantity-selector"]');
    const targetElement = document.querySelector('.option_type_id_1641878');
    
    const handleQuantitySelector = (mode) => {
        if (!quantitySelector) return;
        
        if (mode === "STOCK") {
            if (targetElement && targetElement.parentNode) {
                quantitySelector.style.display = "block";
                targetElement.parentNode.insertBefore(quantitySelector, targetElement.nextSibling);

                setupQuantitySelectorButtons(quantitySelector);
            }
        } else if (mode === "CUSTOM") {
            quantitySelector.style.display = "none";
        }
    };

    // Find the actual option values by looking at data-conditional-value
    const stockOption = Array.from(dropdown.options).find(opt => 
        opt.dataset.conditionalValue === "STOCK"
    );
    const customOption = Array.from(dropdown.options).find(opt => 
        opt.dataset.conditionalValue === "CUSTOM"
    );
    
    const stockValue = stockOption ? stockOption.value : "STOCK";
    const customValue = customOption ? customOption.value : "CUSTOM";

    // the radio indicator (visual toggle)
    const radioIndicator = document.createElement("div");
    radioIndicator.className = "radio-indicator";
    
    // Determine initial state based on data-conditional-value
    const selectedOption = dropdown.options[dropdown.selectedIndex];
    const conditionalValue = selectedOption?.dataset.conditionalValue || "";
    radioIndicator.setAttribute("data-value", conditionalValue);
    
    const stockLabel = document.createElement("label");
    stockLabel.textContent = "STOCK";
    stockLabel.className = "toggle-label stock-label";
    
    const customLabel = document.createElement("label");
    customLabel.textContent = "CUSTOM";
    customLabel.className = "toggle-label custom-label";
    
    const toggleWrapper = document.createElement("div");
    toggleWrapper.className = "toggle-wrapper";
    toggleWrapper.appendChild(stockLabel);
    toggleWrapper.appendChild(customLabel);
    toggleWrapper.appendChild(radioIndicator);
    
    dropdownContainer.insertBefore(toggleWrapper, dropdown);
    
    // Set initial state and handle quantity selector
    if (conditionalValue === "CUSTOM") {
        radioIndicator.classList.add("right");
        customLabel.style.color = colors.selected.text;
        stockLabel.style.color = colors.unselected.text;
        handleQuantitySelector("CUSTOM");
    } else if (conditionalValue === "STOCK") {
        radioIndicator.classList.remove("right");
        stockLabel.style.color = colors.selected.text;
        customLabel.style.color = colors.unselected.text;
        handleQuantitySelector("STOCK");
        setupQuantitySelectorButtons(quantitySelector);
    }
    
    stockLabel.addEventListener("click", () => {
        dropdown.value = stockValue;
        if (hiddenInput) hiddenInput.value = "STOCK";
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
    });
    
    customLabel.addEventListener("click", () => {
        dropdown.value = customValue;
        if (hiddenInput) hiddenInput.value = "CUSTOM";
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));
    });
    
    dropdown.addEventListener("change", (e) => {
        const selectedOpt = e.target.options[e.target.selectedIndex];
        const conditionalVal = selectedOpt?.dataset.conditionalValue || "";
        
        if (hiddenInput) hiddenInput.value = conditionalVal;
        radioIndicator.setAttribute("data-value", conditionalVal);
        
        if (conditionalVal === "CUSTOM") {
            radioIndicator.classList.add("right");
            stockLabel.style.color = colors.unselected.text;
            customLabel.style.color = colors.selected.text;
            this.carouselContainer.style.display = "block";
            handleQuantitySelector("CUSTOM");
            
            // Re-sync all checkbox buttons when switching to CUSTOM
            setTimeout(() => {
                const buttons = document.querySelectorAll('.hulk-check button[type="button"]');
                const checkboxHiddenInput = document.querySelector('#hulkapps_option_1639510_hidden');
                const hiddenValue = checkboxHiddenInput ? checkboxHiddenInput.value : '';
                
                // buttons.forEach(btn => {
                //     const label = btn.previousElementSibling;
                //     if (label && label.classList.contains('hulkapps_check_option')) {
                //         const checkbox = label.querySelector('input[type="checkbox"]');
                //         const isChecked = hiddenValue.includes(checkbox.value);
                        
                //         checkbox.checked = isChecked;
                //         btn.style.background = isChecked ? colors.selected.background : colors.unselected.background;
                //         btn.style.color = isChecked ? colors.selected.text : 'inherit';
                //     }
                // });
            }, 100);
        } else if (conditionalVal === "STOCK") {
            radioIndicator.classList.remove("right");
            stockLabel.style.color = colors.selected.text;
            customLabel.style.color = colors.unselected.text;
            this.carouselContainer.style.display = "none";
            handleQuantitySelector("STOCK");
        }
    });

    this.dropdown = dropdown;
}

setupValidationHandler() {
    const submitBtns = document.querySelectorAll('.hulkapps_submit_cart, .shopify-payment-button__button');

    submitBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            setTimeout(() => {

                const firstError = this.slidesContainer.querySelector('.validation_error');

                if (firstError) {
                    const errorSlide = firstError.closest('.carousel-slide');
                    
                    if (errorSlide) {
                        const stepIndex = parseInt(errorSlide.dataset.step);
                        
                        if (this.currentStep !== stepIndex) {
                            this.showStep(stepIndex);
                            

                            setTimeout(() => {
                                firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            }, 300);
                        }
                    }
                }
            }, 100); 
        });
    });
}

    createCarouselStructure() {

        this.carouselContainer = document.createElement("div");
        this.carouselContainer.className = "product-carousel-container";
        
        const navContainer = document.createElement("div");
        navContainer.className = "carousel-nav";
        
        this.steps.forEach((step, index) => {
            const tab = document.createElement("button");
            tab.className = `carousel-tab ${index === 0 ? 'active' : ''}`;
            tab.textContent = step.label;
            tab.dataset.step = index;
            tab.type = "button";
            navContainer.appendChild(tab);
        });
        
        const contentWrapper = document.createElement("div");
        contentWrapper.className = "carousel-content-wrapper";
        
        const slidesContainer = document.createElement("div");
        slidesContainer.className = "carousel-slides";
        
        this.slides = [];
        this.steps.forEach((step, index) => {
            const slide = document.createElement("div");
            slide.className = `carousel-slide ${index === 0 ? 'active' : ''}`;
            slide.dataset.step = index;
        
            const options = this.optionSet.querySelectorAll(`.hulk-${step.key}`);
            options.forEach(option => {
                slide.appendChild(option);  // MOVE, don't clone
                // Remove the cloneNode(true) and the display:none line
            });
            
            const buttonContainer = document.createElement("div");
            buttonContainer.className = "carousel-buttons";
            
            if (index > 0) {
                const prevBtn = document.createElement("button");
                prevBtn.className = "carousel-prev-btn";
                prevBtn.textContent = "Previous";
                prevBtn.dataset.step = index;
                prevBtn.type = "button";
                buttonContainer.appendChild(prevBtn);
            }
            
            if (index < this.steps.length - 1) {
                const nextBtn = document.createElement("button");
                nextBtn.className = "carousel-next-btn";
                if (index === 0) {
                    nextBtn.textContent = "NEXT → Choose Shaft";
                } else if (index === 1) {
                    nextBtn.textContent = "NEXT → Choose Grip";
                } else {
                    nextBtn.textContent = "NEXT";
                }
                nextBtn.dataset.step = index;
                nextBtn.type = "button";
                buttonContainer.appendChild(nextBtn);
            }
            
            slide.appendChild(buttonContainer);
            
            slidesContainer.appendChild(slide);
            this.slides.push(slide);
        });
        
        contentWrapper.appendChild(slidesContainer);
        this.carouselContainer.appendChild(navContainer);
        this.carouselContainer.appendChild(contentWrapper);
        
        // insert carousel after hulk-fixed elements
        const fixedElements = this.optionSet.querySelectorAll('.hulk-fixed');
        const lastFixed = fixedElements[fixedElements.length - 1];
        
        if (lastFixed) {
            lastFixed.parentNode.insertBefore(this.carouselContainer, lastFixed.nextSibling);
        } else {
            this.optionSet.insertBefore(this.carouselContainer, this.optionSet.firstChild);
        }

        this.slidesContainer = slidesContainer;
        this.navContainer = navContainer;
        
        // hide if STOCK is selected
        if (this.dropdown && this.dropdown.value === "STOCK") {
            this.carouselContainer.style.display = "none";
        }
    }

    setupNavigation() {
        const tabs = this.navContainer.querySelectorAll('.carousel-tab');
        tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const step = parseInt(tab.dataset.step);
                this.showStep(step);
            });
        });
    }

    setupButtons() {
        // Setup Next buttons
        const nextButtons = this.carouselContainer.querySelectorAll('.carousel-next-btn');
        nextButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const currentStep = parseInt(btn.dataset.step);
                if (currentStep < this.steps.length - 1) {
                    this.showStep(currentStep + 1);
                }
            });
        });
        
        // Setup Previous buttons
        const prevButtons = this.carouselContainer.querySelectorAll('.carousel-prev-btn');
        prevButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const currentStep = parseInt(btn.dataset.step);
                if (currentStep > 0) {
                    this.showStep(currentStep - 1);
                }
            });
        });
    }

    setupSubmitButtons() {
        this.submitCart = document.querySelector('.hulkapps_submit_cart');
        this.shopifyPayment = document.querySelector('.shopify-payment-button');
        
        if (this.submitCart || this.shopifyPayment) {
            const submitContainer = document.createElement('div');
            submitContainer.className = 'carousel-submit-container';
            
            if (this.submitCart) {
                submitContainer.appendChild(this.submitCart);
            }
            if (this.shopifyPayment) {
                submitContainer.appendChild(this.shopifyPayment);
            }
            
            this.submitContainer = submitContainer;
            
            const currentValue = this.dropdown ? this.dropdown.value : null;
            const selectedOption = this.dropdown?.options[this.dropdown.selectedIndex];
            const conditionalValue = selectedOption?.dataset.conditionalValue || currentValue;
            
            if (conditionalValue === 'CUSTOM') {
                const lastSlide = this.slides[this.slides.length - 1];
                lastSlide.appendChild(submitContainer);
                
                submitContainer.style.display = this.currentStep === this.steps.length - 1 ? 'block' : 'none';
            } else {
                const productOptions = document.querySelector('.hulkapps_product_options');
                if (productOptions) {
                    productOptions.parentNode.insertBefore(submitContainer, productOptions.nextSibling);
                } else {
                    this.optionSet.parentNode.insertBefore(submitContainer, this.optionSet.nextSibling);
                }
                
                submitContainer.style.display = 'block';
            }
            
            if (this.dropdown) {
                this.dropdown.addEventListener('change', (e) => {
                    const selectedOpt = e.target.options[e.target.selectedIndex];
                    const conditionalVal = selectedOpt?.dataset.conditionalValue || e.target.value;
                    this.repositionSubmitButtons(conditionalVal);
                });
            }
        }
    }

    repositionSubmitButtons(value) {
        if (!this.submitContainer) return;
        
        if (value === 'CUSTOM') {
            const lastSlide = this.slides[this.slides.length - 1];
            lastSlide.appendChild(this.submitContainer);
            
            this.submitContainer.style.display = this.currentStep === this.steps.length - 1 ? 'block' : 'none';
        } else if (value === 'STOCK') {
            const productOptions = document.querySelector('.hulkapps_product_options');
            if (productOptions) {
                productOptions.parentNode.insertBefore(this.submitContainer, productOptions.nextSibling);
            } else {
                this.optionSet.parentNode.insertBefore(this.submitContainer, this.optionSet.nextSibling);
            }
            
            this.submitContainer.style.display = 'block';
        }
    }

    setupDropdownListeners() {
        setTimeout(() => {
            const dropdowns = this.carouselContainer.querySelectorAll('.hulkapps_product_options_ul_parent');
            
            dropdowns.forEach(dropdown => {
                dropdown.addEventListener('click', () => {
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            this.adjustHeight(this.currentStep);
                        }, 350);
                    });
                });
            });
            
            document.addEventListener('click', (e) => {
                if (!e.target.closest('.hulkapps_product_options_ul_parent')) {
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            this.adjustHeight(this.currentStep);
                        }, 350);
                    });
                }
            });
        }, 500);
    }

    showStep(stepIndex) {
        this.currentStep = stepIndex;
        
        const tabs = this.navContainer.querySelectorAll('.carousel-tab');
        tabs.forEach((tab, index) => {
            if (index === stepIndex) {
                tab.classList.add('active');
            } else {
                tab.classList.remove('active');
            }
        });
        
        this.slides.forEach((slide, index) => {
            if (index === stepIndex) {
                slide.classList.add('active');
            } else {
                slide.classList.remove('active');
            }
        });
        
        const translateX = -stepIndex * 100;
        this.slidesContainer.style.transform = `translateX(${translateX}%)`;
        
        this.adjustHeight(stepIndex);
        
        if (this.submitContainer) {
            const selectedOption = this.dropdown?.options[this.dropdown?.selectedIndex];
            const conditionalValue = selectedOption?.dataset.conditionalValue || this.dropdown?.value;
            
            if (conditionalValue === 'CUSTOM') {
                this.submitContainer.style.display = stepIndex === this.steps.length - 1 ? 'block' : 'none';
            }
        }
    }

    adjustHeight(stepIndex) {
        const activeSlide = this.slides[stepIndex];
        const contentWrapper = this.carouselContainer.querySelector('.carousel-content-wrapper');
        
        requestAnimationFrame(() => {
            void activeSlide.offsetHeight;
            void contentWrapper.offsetHeight;
            
            const slideHeight = activeSlide.scrollHeight;
            
            contentWrapper.style.height = `${slideHeight}px`;
        });
    }

    setupQuantitySelectorButtons(selector) {
        const input = selector.querySelector('.hulk-input');
        const decreaseBtn = selector.querySelector('.hulk-dec');
        const increaseBtn = selector.querySelector('.hulk-inc');
        
        if (!input || !decreaseBtn || !increaseBtn) return;
        
        // Remove any existing listeners by cloning and replacing
        const newDecreaseBtn = decreaseBtn.cloneNode(true);
        const newIncreaseBtn = increaseBtn.cloneNode(true);
        decreaseBtn.parentNode.replaceChild(newDecreaseBtn, decreaseBtn);
        increaseBtn.parentNode.replaceChild(newIncreaseBtn, increaseBtn);
        
        // Add fresh listeners
        newIncreaseBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const step = parseFloat(input.step) || 1;
            const max = input.max ? parseFloat(input.max) : Infinity;
            const newValue = parseFloat(input.value) + step;
            
            if (newValue <= max) {
                input.value = newValue;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            // Update button states
            newDecreaseBtn.disabled = newValue <= (parseFloat(input.min) || 0);
            newIncreaseBtn.disabled = newValue >= max;
        });
        
        newDecreaseBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const step = parseFloat(input.step) || 1;
            const min = parseFloat(input.min) || 0;
            const newValue = parseFloat(input.value) - step;
            
            if (newValue >= min) {
                input.value = newValue;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            // Update button states
            newDecreaseBtn.disabled = newValue <= min;
            newIncreaseBtn.disabled = false;
        });
        
        // Set initial button states
        const currentValue = parseFloat(input.value);
        const min = parseFloat(input.min) || 0;
        const max = input.max ? parseFloat(input.max) : Infinity;
        newDecreaseBtn.disabled = currentValue <= min;
        newIncreaseBtn.disabled = currentValue >= max;
    }

    applyStyles() {
        const styleId = 'product-carousel-styles';
        if (document.getElementById(styleId)) return;
        
        const style = document.createElement('style');
        style.id = styleId;

        document.head.appendChild(style);
        
        this.slides.forEach(slide => {
            const options = slide.querySelectorAll('.hulkapps_option');
            options.forEach((option, index) => {
                option.style.setProperty('--item-index', index);
            });
        });
    }
}

function cleanAllLabels() {
  document.querySelectorAll('.radio_div').forEach(div => {
    div.textContent = div.textContent.replace(/\s*\([^)]*\)/g, '').trim();
  });
}


function addSelectedImageDisplay() {
  const optionElements = document.querySelectorAll('.hulkapps_option');
  
  optionElements.forEach(optionElement => {
    const parentDiv = optionElement.querySelector('.hulkapps_product_options_ul_parent');
    
    if (!parentDiv) return;
    
    if (optionElement.querySelector('.hulkapps_selected_image')) return;
    
    const imageContainer = document.createElement('div');
    imageContainer.className = 'hulkapps_selected_image';
    
    const img = document.createElement('img');
    img.alt = 'Selected option';
    imageContainer.appendChild(img);
    
    parentDiv.parentNode.insertBefore(imageContainer, parentDiv.nextSibling);
    
    const selectedLi = parentDiv.querySelector('li.dropdown_selected');
    if (selectedLi) {
      const selectedImg = selectedLi.querySelector('.dropdown_img img');
      if (selectedImg) {
        img.src = selectedImg.src;
      }
    }
    
    const allListItems = parentDiv.querySelectorAll('li.dropdown_swatch');
    allListItems.forEach(li => {
      li.addEventListener('click', function() {
        const clickedImg = this.querySelector('.dropdown_img img');
        if (clickedImg) {
          img.src = clickedImg.src;
        }
      });
    });
  });
}

function replaceCheckbox() {
    // Color configuration
    const colors = {
        selected: {
            background: 'black',
            text: 'white'
        },
        unselected: {
            background: 'transparent',
            text: 'inherit'
        }
    };

    const checkboxLabels = document.querySelectorAll('.hulk-check .hulkapps_check_option');
    const hiddenInput = document.querySelector('[name*="properties[Club numbers]"]');

    checkboxLabels.forEach(label => {
        const checkbox = label.querySelector('input[type="checkbox"]');
        const ariaLabel = label.getAttribute('aria-label');
        
        const buttonText = ariaLabel.split('[')[0].trim();
        
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = buttonText;
        button.style.cssText = `
            padding: 10px 20px;
            background: ${colors.unselected.background};
            color: ${colors.unselected.text};
            border: 1px solid currentColor;
            cursor: pointer;
            margin-right: 5px;
            margin-top: 5px;
            border: 1px solid black;
        `;
        
        // Function to sync button style with checkbox state
        const syncButtonStyle = () => {
            const hiddenValue = hiddenInput ? hiddenInput.value : '';
            const isChecked = hiddenValue.includes(checkbox.value);
            
            checkbox.checked = isChecked;
            
            if (isChecked) {
                button.style.background = colors.selected.background;
                button.style.color = colors.selected.text;
            } else {
                button.style.background = colors.unselected.background;
                button.style.color = colors.unselected.text;
            }
        };
        
        // Initial sync
        syncButtonStyle();
        
        button.addEventListener('click', () => {
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            syncButtonStyle();
        });
        
        // Watch for changes to the hidden input
        if (hiddenInput) {
            const observer = new MutationObserver(() => {
                syncButtonStyle();
            });
            
            observer.observe(hiddenInput, {
                attributes: true,
                attributeFilter: ['value']
            });
        }
        
        label.style.position = 'absolute';
        label.style.opacity = '0';
        label.style.pointerEvents = 'none';
        label.style.width = '1px';
        label.style.height = '1px';
        label.style.overflow = 'hidden';
        label.parentNode.insertBefore(button, label.nextSibling);
    });
}

function updateOptionSetText() {

  const container = document.querySelector('.hulkapps_option_set');
  if (!container) return;

  const specificProductIds = [
    '8199131103407',
    '6215126614191',
    '8074998644911',
    '7762448777391',
    '7883408015535',
    '7570449629359',
    '6215125008559',
  ];

  const isSpecificProduct = specificProductIds.some(id =>
    window.location.href.includes(id) ||
    document.querySelector(`[data-product-id="${id}"]`) !== null
  );

  const specificReplacements = isSpecificProduct
    ? [
        { source: 'LOFT\\s+TYPE',                 flags: 'gi', replacement: 'SELECT LOFT'            },
        { source: 'LOFT\\s*\\(WEDGE\\)',           flags: 'gi', replacement: 'LOFT ADJUSTMENT' },
        { source: 'LIE\\s*\\(WEDGE\\)',            flags: 'gi', replacement: 'LIE ADJUSTMENT'  },
        { source: 'LOFT\\s*\\(IRON\\s+SET\\)',     flags: 'gi', replacement: 'LOFT ADJUSTMENT' },
        { source: 'LIE\\s*\\(IRON\\s+SET\\)',      flags: 'gi', replacement: 'LIE ADJUSTMENT'  },
        { source: 'LOFT\\s*\\(HYBRID\\s+IRON\\)',  flags: 'gi', replacement: 'LOFT ADJUSTMENT' },
        { source: 'LIE \\s*\\(HYBRID\\s+IRON\\)',   flags: 'gi', replacement: 'LIE ADJUSTMENT'  },
        // No standalone LOFT → HEAD rule here since LOFT TYPE already maps to HEAD above
      ]
    : [
        { source: 'LOFT\\s+TYPE',                 flags: 'gi', replacement: 'LOFT ADJUSTMENT' },
        { source: 'LIE\\s*\\(WEDGE\\)',            flags: 'gi', replacement: 'LIE ADJUSTMENT'  },
        { source: 'LOFT\\s*\\(IRON\\s+SET\\)',     flags: 'gi', replacement: 'LOFT ADJUSTMENT' },
        { source: 'LIE\\s*\\(IRON\\s+SET\\)',      flags: 'gi', replacement: 'LIE ADJUSTMENT'  },
        { source: 'LOFT\\s*\\(HYBRID\\s+IRON\\)',  flags: 'gi', replacement: 'LOFT ADJUSTMENT' },
        { source: 'LIE\\s*\\(HYBRID\\s+IRON\\)',   flags: 'gi', replacement: 'LIE ADJUSTMENT'  },
        // Standalone LOFT → HEAD must come LAST so specific rules fire first
        { source: '\\bLOFT\\b(?!\\s*ADJUSTMENT)',  flags: 'gi', replacement: 'HEAD'            },
      ];

  // Process option name elements first
  container.querySelectorAll('.hulkapps_option_name').forEach(el => {
    console.log(JSON.stringify(el.textContent));
    const original = el.textContent;
    let text = original;

    specificReplacements.forEach(({ source, flags, replacement }) => {
      text = text.replace(new RegExp(source, flags), replacement);
    });

    // Always strip remaining parentheticals after replacements
    text = text.replace(/\s*\(.*?\)/g, '').trim();

    el.textContent = text;
  });

  // Walker pass for all other text nodes (section titles, labels, etc.)
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);

  let node;
  while ((node = walker.nextNode())) {
    let text = node.textContent;

    specificReplacements.forEach(({ source, flags, replacement }) => {
      const pattern = new RegExp(source, flags);
      if (pattern.test(text)) {
        text = text.replace(new RegExp(source, flags), replacement);
      }
    });

    if (text !== node.textContent) {
      node.textContent = text;
    }
  }
}


// Handles syncing the quantity input with selected clubs
// and resetting quantity when Set Type changes between STOCK and CUSTOM
function setupClubQuantitySync() {
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (!quantityInput) return;

    const clubButtons = document.querySelectorAll('.hulk-charge button[type="button"]');
    const setTypeSelect = document.querySelector('.hulk-type .hulkapps_option_value select');

    const getSetTypeConditionalValue = () => {
        if (!setTypeSelect) return '';
        const selectedOpt = setTypeSelect.options[setTypeSelect.selectedIndex];
        return selectedOpt?.dataset.conditionalValue || setTypeSelect.value || '';
    };

    const isCustomSelected = () => getSetTypeConditionalValue().toUpperCase() === 'CUSTOM';
    const isStockSelected = () => getSetTypeConditionalValue().toUpperCase() === 'STOCK';

    const updateQuantity = (val) => {
        const numericVal = Math.max(1, parseInt(val, 10) || 1);
        if (quantityInput.value === String(numericVal)) return;

        quantityInput.value = numericVal;
        // Trigger change event in case Shopify theme listens for it
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    // Count selected club buttons and sync quantity (only in CUSTOM mode)
    const countSelectedClubsAndUpdateQty = () => {
        // if (!isCustomSelected()) return;

        const selectedClubButtons = document.querySelectorAll(
            '.hulk-charge button[type="button"][style*="background: black"]'
        );

        const count = selectedClubButtons.length;
        updateQuantity(Math.max(count, 1)); 

        return count;
    };

    // Add click listeners to all club buttons
    clubButtons.forEach(button => {
        button.addEventListener('click', () => {
            // Small delay to let the DOM update with new styles
            setTimeout(countSelectedClubsAndUpdateQty, 50);
        });
    });

    // React to Set Type changes
    if (setTypeSelect) {
        setTypeSelect.addEventListener('change', () => {
            if (isStockSelected()) {
                // Instead of hard-reset, sync with actual selection
                setTimeout(countSelectedClubsAndUpdateQty, 50);
            } else if (isCustomSelected()) {
                setTimeout(countSelectedClubsAndUpdateQty, 50);
            }
        });
    }

    // Initial sync based on current Set Type
    if (isStockSelected()) {
        updateQuantity(1);
    } else if (isCustomSelected()) {
        countSelectedClubsAndUpdateQty();
    }
}

function setupCustomGrandTotal() {
    function updateDisplay() {
        const submitContainer = document.querySelector('.carousel-submit-container');
        if (!submitContainer) return; 

        // 1. ROBUST BASE PRICE GETTER
        let basePrice = 0;
        if (window.hulkapps?.product?.selected_variant_price) {
            basePrice = window.hulkapps.product.selected_variant_price;
        } else if (typeof product_price !== 'undefined') {
            basePrice = product_price; 
        } else if (window.cproduct_price) {
            basePrice = window.cproduct_price;
        } else if (window.hulkapps?.product?.price) {
            basePrice = window.hulkapps.product.price;
        }

        let perItemAddons = 0;
        let oneTimeAddons = 0;

        // Helper to sort prices into the correct math bucket
        const processElement = (el) => {
            const price = parseFloat(el.dataset.price) || 0;
            // Only .hulk-check items are one-time charges
            if (el.closest('.hulk-check')) {
                oneTimeAddons += price;
            } else {
                perItemAddons += price;
            }
        };

        // A. Find standard checked inputs (Checkboxes/Radios)
        document.querySelectorAll('.hulkapps_option_child:checked').forEach(processElement);

        // B. Find standard select dropdowns
        document.querySelectorAll('select.hulkapps_option_child option:checked').forEach(processElement);

        // C. Find Hulk Color/Image Dropdowns (Shaft, Grip, etc.)
        // These use <li> tags with a specific class instead of standard inputs
        document.querySelectorAll('.hulkapps_option_child .dropdown_selected').forEach(processElement);

        // 2. GRAB QUANTITY
        const qtyInput = document.querySelector('input[name="quantity"]');
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        // 3. CALCULATE MATH
        const formattedBasePrice = Number(basePrice) / 100;
        const grandTotal = ((formattedBasePrice + perItemAddons) * quantity) + oneTimeAddons;

        // 4. UPDATE UI
        let displayEl = document.getElementById('custom-grand-total-display');
        if (!displayEl) {
            displayEl = document.createElement('div');
            displayEl.id = 'custom-grand-total-display';
            displayEl.style.cssText = 'margin-top: 15px; text-align: center; font-weight: bold; font-size: 16px; letter-spacing: 1px;';
            submitContainer.parentNode.insertBefore(displayEl, submitContainer.nextSibling);
        }

        const currencySymbol = window.hulk_po_currency_symbol || '$';
        displayEl.textContent = `GRAND TOTAL: ${currencySymbol}${grandTotal.toFixed(2)}`;

        const priceSpan = document.querySelector('[data-block-id="price"] .money');
        priceSpan.textContent = `${currencySymbol}${grandTotal.toFixed(2)}`;
    }

    // Natively listen for quantity changes
    document.addEventListener('change', function(e) {
        if (e.target && e.target.name === 'quantity') {
            updateDisplay();
        }
    });

    // Intercept Hulk's calculation function to trigger our update
    const checkHulkReady = setInterval(() => {
        if (typeof window.calc_options_total === 'function') {
            clearInterval(checkHulkReady);
            const originalCalc = window.calc_options_total;
            window.calc_options_total = function() {
                originalCalc.apply(this, arguments);
                setTimeout(updateDisplay, 50); 
            };
        }
    }, 100);

    // Initial render
    const initInterval = setInterval(() => {
        if (document.querySelector('.carousel-submit-container')) {
            clearInterval(initInterval);
            if (typeof window.calc_options_total === 'function' && window.hulkapps?.product_id) {
                window.calc_options_total(window.hulkapps.product_id, 'hulkapps_product_options');
            } else {
                updateDisplay();
            }
        }
    }, 200);

    setTimeout(() => { clearInterval(checkHulkReady); clearInterval(initInterval); }, 10000);
}


document.addEventListener('DOMContentLoaded', () => {
    const hook = setInterval(() => {

        let hulkDiv = document.querySelector('.hulkapps_option_set');
        
        if (hulkDiv) {
            clearInterval(hook);
            
            try { new ProductOptionsCarousel(); } catch(e) { console.error("Carousel Init Error", e); }
            try { cleanAllLabels(); } catch(e) {}
            try { addSelectedImageDisplay(); } catch(e) {}
            try { replaceCheckbox(); } catch(e) {}
            try { setupClubQuantitySync(); } catch(e) {}
            try { updateOptionSetText(); } catch(e) {}
            try { setupCustomGrandTotal(); } catch(e) {}
        }
    }, 150);

    setTimeout(() => {
        clearInterval(hook);
    }, 10000);
});

